import {TOption} from './TOption'

export const ORDER_STATUS_OUTSTANDING: TOption[] = [
  {value: '0', label: 'Dikirimkan'},
  {value: '1', label: 'Ditinjau'},
  {value: '2', label: 'Revisi'},
  {value: '3', label: 'Proses Negosiasi'},
  {value: '6', label: 'Negosiasi-Diterima'},
]
